var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "615px",
    height: "701px",
    viewBox: "0 0 615 701",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "welcome") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "welcome",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M294.34343,657.211947 L293.56175,639.635887 C293.480503,639.592767 293.399153,639.549837 293.3177,639.507097 C284.94164,635.111967 275.34194,643.068097 278.0173,652.141017 C280.53452,660.677617 282.22576,669.880597 286.83343,677.352637 C292.348044,686.143938 301.561577,691.950073 311.8719,693.131247 L322.51356,699.646797 C325.468731,683.172254 321.061881,666.22982 310.45403,653.283117 C307.477947,649.723393 304.065434,646.552615 300.29703,643.845617 C297.74832,650.566027 294.34343,657.211947 294.34343,657.211947 Z",
    id: "Path",
    fillOpacity: 0.946807221,
    fill: "#75A070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.06733,478.844487 C178.5795,457.715177 148.88966,445.597367 117.61067,445.597367 L116.40415,445.600607 C95.8015314,445.608479 75.5665068,440.143892 57.76869,429.765757 L55.91664,428.686637 L57.40831,427.149637 C65.4839118,418.794584 72.227061,409.247691 77.40148,398.843477 C69.961615,405.77977 59.8257403,409.054128 49.73397,407.781367 C39.0714863,406.510273 29.5772081,400.429014 23.96381,391.275107 C13.0315,373.537237 0,348.368527 0,329.194807 C0.0344091592,296.425811 13.8481448,265.181947 38.0631,243.103807 C53.3972032,229.277355 62.1240349,209.579514 62.06291,188.932437 L62.05684,187.479597 C62.0547987,174.038976 63.6972685,160.648596 66.94764,147.606917 L67.27769,146.289977 L68.63269,146.337297 C77.3705085,146.634633 86.1129502,145.902225 94.6795,144.155197 C86.644072,143.16957 78.7832835,141.078814 71.31996,137.942197 L69.86227,137.352487 L70.35697,135.858787 C104.45815,114.744617 181.43433,125.678617 226.11361,23.4552374 C262.34243,-59.4340326 390.16991,97.0361074 390.16991,187.479617 C390.16991,196.708317 381.03667,208.903847 387.87376,215.003527 C461.78355,280.941797 410.78684,323.283247 394.70842,365.888867 C390.89363,375.997577 399.16524,387.094997 399.16524,398.031357 C399.16524,399.887047 399.11792,401.802597 399.02448,403.724627 L398.88211,406.679627 L396.4177,405.039917 C391.542658,401.846208 387.023676,398.139575 382.93806,393.983427 C391.523062,413.739721 390.693441,436.322045 380.68194,455.395147 C372.93642,470.014147 365.44287,480.480147 358.41001,486.500217 C311.64086,526.52325 241.784038,523.166926 199.06733,478.844477 L199.06733,478.844487 Z",
    id: "Path",
    fill: "#FAEDCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.80795,698.779647 C323.849156,698.779647 324.73117,698.012066 324.87788,696.981247 C324.96681,696.356357 333.67837,633.527457 325.8544,550.025247 C318.62892,472.908927 295.425,361.834247 225.9151,270.610467 C225.462152,270.014475 224.725446,269.705686 223.982909,269.800592 C223.240372,269.895497 222.605015,270.379654 222.31653,271.070411 C222.028045,271.761167 222.130339,272.553394 222.58482,273.148217 C291.49436,363.584217 314.51122,473.843887 321.68576,550.415717 C329.46425,633.432077 320.821,695.771017 320.73276,696.391137 C320.647787,696.992124 320.827612,697.600425 321.225696,698.058611 C321.62378,698.516797 322.200996,698.779647 322.80796,698.779647 L322.80795,698.779647 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.08375,399.285818 C266.990927,399.286542 267.795339,398.702885 268.076083,397.840242 C268.356828,396.977598 268.05001,396.032296 267.31617,395.498957 C267.06386,395.315647 241.63517,376.993337 203.6196,363.073957 C168.47707,350.208067 115.0376,338.544257 60.0226,356.053597 C59.3088417,356.279464 58.7700525,356.869327 58.6095759,357.600568 C58.4490993,358.33181 58.6913709,359.093083 59.2449555,359.597078 C59.7985402,360.101072 60.5791437,360.271045 61.29216,360.042847 C115.18001,342.893317 167.65078,354.364267 202.18,367.005967 C239.65293,380.726407 264.607,398.705967 264.85472,398.885847 C265.211693,399.145979 265.642051,399.285818 266.08375,399.285818 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.89603,160.653367 C361.962075,159.748602 361.437862,158.904255 360.59768,158.56212 C359.757499,158.219986 358.792561,158.457928 358.20776,159.151447 C358.00676,159.389897 337.90076,183.433107 321.27976,220.347537 C305.91649,254.472287 290.43453,306.933017 303.9365,363.066087 C304.206843,364.190072 305.33717,364.882086 306.461155,364.611742 C307.58514,364.341399 308.277153,363.211072 308.00681,362.087087 C294.78254,307.104087 310.00239,255.595677 325.09789,222.066507 C341.48131,185.678947 361.21124,162.084507 361.40851,161.850347 C361.693689,161.513058 361.864398,161.093924 361.89603,160.653367 L361.89603,160.653367 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.06291,268.597367 C360.82914,282.847737 370.7035,294.597367 385.06291,294.597367 C399.422313,294.597367 411.06291,282.956771 411.06291,268.597367 C411.06291,254.237967 399.36076,243.924957 385.06291,242.597367 C369.89201,241.188707 356.79527,250.301687 359.06291,268.597367 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB6B6",
    points: "397.105 687.327997 407.006 687.326997 411.716 649.136997 397.103 649.137997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.75698,697.656407 L427.20398,697.655247 L427.20398,697.270247 C427.203505,690.725452 421.897966,685.419993 415.35317,685.419617 L415.35243,685.419617 L409.79091,681.200387 L399.41432,685.420297 L396.75649,685.420357 L396.75698,697.656407 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB6B6",
    points: "358.105 687.327997 368.006 687.326997 372.716 649.136997 358.103 649.137997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.75698,697.656407 L388.20398,697.655247 L388.20398,697.270247 C388.203505,690.725452 382.897966,685.419993 376.35317,685.419617 L376.35243,685.419617 L370.79091,681.200387 L360.41432,685.420297 L357.75649,685.420357 L357.75698,697.656407 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.17708,448.136757 L438.17708,472.136757 L429.93062,573.781617 C429.93062,573.781617 434.17708,580.136727 431.17708,580.136727 C428.17708,580.136727 424.33022,581.546147 426.75368,585.341437 C429.17714,589.136727 420.89368,602.762337 420.89368,602.762337 L409.17707,675.136727 L394.24793,674.916267 C394.24793,674.916267 386.65784,670.687937 390.91743,666.412267 C395.17702,662.136597 398.17701,662.136697 394.17701,658.136697 C390.17701,654.136697 390.17701,655.341407 390.17701,652.239047 C390.17701,649.136687 386.1695,611.223307 395.67329,596.680047 L392.80964,537.384757 L386.06507,595.546197 L372.17707,673.136717 L357.79536,673.018247 C357.79536,673.018247 351.1526,666.615537 351.16486,661.876157 C351.17712,657.136777 355.26905,656.743037 352.22309,653.939877 C349.17713,651.136717 349.17709,608.073727 358.17709,584.136717 C358.17709,584.136717 363.26817,570.762787 358.16554,566.180057 C353.06291,561.597327 358.15923,556.353537 358.15923,556.353537 C358.15923,556.353537 366.24095,553.432087 358.15193,545.014707 C350.06291,536.597327 358.10824,477.065577 358.10824,477.065577 C358.10824,477.065577 349.26553,453.034907 358.22134,443.585807 C367.17715,434.136707 431.17708,448.136757 431.17708,448.136757 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.50254,489.486357 L318.99179,459.304057 L328.83179,464.770727 L322.88926,495.473797 C324.542135,500.875947 321.807734,506.647852 316.580513,508.790603 C311.353292,510.933354 305.354348,508.741437 302.739888,503.733461 C300.125427,498.725486 301.756278,492.550362 306.50255,489.486357 L306.50254,489.486357 Z",
    id: "Path",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.07663,250.815617 L497.07348,277.383127 L488.72804,269.829127 L501.47274,241.271027 C501.086853,235.634861 505.057928,230.632613 510.634711,229.729962 C516.211493,228.82731 521.557786,232.32146 522.969549,237.791579 C524.381312,243.261699 521.393712,248.906712 516.07663,250.815617 L516.07663,250.815617 Z",
    id: "Path",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.06291,450.597367 C445.38859,469.715677 383.43154,493.977917 359.65843,484.237367 C355.49563,482.531767 341.17631,476.898187 350.96404,469.087787 C360.75177,461.277387 349.82924,460.178267 349.57104,455.093867 C349.39844,451.694687 352.03021,444.237947 349.2843,444.557667 C346.53839,444.877387 343.32455,440.176567 349.3048,438.153667 C355.28505,436.130767 349.36891,434.285997 349.42131,432.365797 C349.99317,411.410417 366.0711,378.078897 366.0711,378.078897 L337.1001,452.135717 C337.1001,452.135717 337.3141,464.947947 333.61961,461.032717 C329.92512,457.117487 330.19396,469.789467 330.19396,469.789467 C330.19396,469.789467 324.70042,473.623357 327.85944,475.757067 C331.01846,477.890777 324.45844,484.450767 324.45844,484.450767 L309.15178,483.357427 C309.15178,483.357427 309.39142,471.986747 312.00493,469.472097 C314.61844,466.957447 313.33468,463.000657 313.33468,463.000657 C313.33468,463.000657 320.13925,456.977177 315.57736,452.086367 C309.71024,445.796237 331.10153,339.556437 338.48373,340.608527 C340.611895,330.251539 348.369871,321.963707 358.5639,319.156917 L375.09611,314.605007 L378.03175,302.957517 L401.31027,302.957517 L405.36507,310.610847 L423.0629,318.597417 C426.39652,313.893897 428.88767,308.937507 442.53836,307.330847 C442.53836,307.330847 479.32091,273.864017 477.52504,271.250847 C475.72917,268.637677 481.43104,262.519757 481.43104,262.519757 C481.43104,262.519757 486.3006,260.925987 483.55283,260.075087 C480.80506,259.224187 485.99883,257.256827 485.99883,257.256827 C485.99883,257.256827 490.80911,255.992827 488.5404,254.328507 C486.27169,252.664187 496.11168,251.570857 496.11168,251.570857 L508.87868,261.987657 L506.29831,266.363067 C506.29831,266.363067 507.87161,272.321067 505.81831,270.145957 C503.76501,267.970847 503.37848,274.283057 503.37848,274.283057 C503.37848,274.283057 502.32988,281.195057 496.11166,283.277517 C489.89344,285.359977 485.17843,305.144117 485.17843,305.144117 C470.51363,324.211417 453.20711,339.085617 432.69843,348.877427 C440.69126,358.051747 433.06291,450.597367 433.06291,450.597367 Z",
    id: "Path",
    fill: "#C89210"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB6B6",
    cx: 387.93692,
    cy: 273.085557,
    r: 23.0557
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.06291,275.597367 C364.79291,280.607367 369.06291,287.597367 368.06291,287.597367 C367.06291,287.597367 359.95291,266.944047 367.06291,265.597367 C372.22013,264.620557 373.37291,265.477367 378.19291,263.387367 L377.51291,264.027367 C380.70291,266.347367 385.14291,264.917367 388.78291,263.407367 C392.43291,261.907367 396.86291,260.477367 400.06291,262.787367 C402.07291,264.237367 402.92291,266.757367 404.17291,268.897367 C405.42291,271.047367 407.73291,273.077367 410.11291,272.417367 C412.02291,271.887367 413.12291,269.747317 413.112978,267.767367 C413.10291,265.787417 410.52466,263.903817 411.39291,262.127367 C413.9661,256.862927 411.65207,253.274617 406.04291,250.797367 C404.00291,250.487367 401.96291,250.170701 399.92291,249.847367 C400.991893,248.366716 402.287831,247.064027 403.76291,245.987367 C403.139779,244.389505 402.062031,243.009293 400.66291,242.017367 C399.03291,241.047367 397.01291,241.117367 395.12291,241.217367 C390.90291,241.437367 386.686243,241.657367 382.47291,241.877367 C379.35291,242.037367 376.12291,242.227367 373.33296,243.657367 C369.85296,245.447367 367.57296,248.937367 365.91291,252.487367 C362.19291,260.467367 362.78288,266.887407 364.06291,275.597367 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.15243,700.253897 L494.90243,700.561237 C495.560027,700.561237 496.093115,700.02815 496.093115,699.370552 C496.093115,698.712955 495.560027,698.179867 494.90243,698.179867 L268.15243,697.872537 C267.494836,697.872537 266.96175,698.405623 266.96175,699.063217 C266.96175,699.720812 267.494836,700.253897 268.15243,700.253897 Z",
    id: "Path",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(178.664658, 595.374817) rotate(-81.721740) translate(-178.664658, -595.374817) ",
    cx: 178.664658,
    cy: 595.374817,
    rx: 5.25681,
    ry: 7.55666
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(227.836182, 590.576764) rotate(-81.721740) translate(-227.836182, -590.576764) ",
    cx: 227.836182,
    cy: 590.576764,
    rx: 5.2568,
    ry: 7.55666
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF6584",
    transform: "translate(165.200045, 555.566655) rotate(-81.721740) translate(-165.200045, -555.566655) ",
    cx: 165.200045,
    cy: 555.566655,
    rx: 5.25681,
    ry: 7.55666
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(147.989480, 540.323551) rotate(-89.566750) translate(-147.989480, -540.323551) ",
    cx: 147.98948,
    cy: 540.323551,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(140.743759, 509.951947) rotate(-89.566750) translate(-140.743759, -509.951947) ",
    cx: 140.743759,
    cy: 509.951947,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(197.088919, 563.403848) rotate(-89.566750) translate(-197.088919, -563.403848) ",
    cx: 197.088919,
    cy: 563.403848,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF6584",
    transform: "translate(173.327113, 575.267849) rotate(-89.566750) translate(-173.327113, -575.267849) ",
    cx: 173.327113,
    cy: 575.267849,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(206.404382, 597.195583) rotate(-89.566750) translate(-206.404382, -597.195583) ",
    cx: 206.404382,
    cy: 597.195583,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(556.664678, 441.374809) rotate(-81.721740) translate(-556.664678, -441.374809) ",
    cx: 556.664678,
    cy: 441.374809,
    rx: 5.25681,
    ry: 7.55666
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(605.836203, 436.576755) rotate(-81.721740) translate(-605.836203, -436.576755) ",
    cx: 605.836203,
    cy: 436.576755,
    rx: 5.2568,
    ry: 7.55666
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF6584",
    transform: "translate(543.199208, 401.566692) rotate(-81.721777) translate(-543.199208, -401.566692) ",
    cx: 543.199208,
    cy: 401.566692,
    rx: 5.25680689,
    ry: 7.55665553
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(525.989505, 386.323547) rotate(-89.566750) translate(-525.989505, -386.323547) ",
    cx: 525.989505,
    cy: 386.323547,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(518.743764, 355.951943) rotate(-89.566750) translate(-518.743764, -355.951943) ",
    cx: 518.743764,
    cy: 355.951943,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(575.088934, 409.403844) rotate(-89.566750) translate(-575.088934, -409.403844) ",
    cx: 575.088934,
    cy: 409.403844,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF6584",
    transform: "translate(551.327128, 421.267845) rotate(-89.566750) translate(-551.327128, -421.267845) ",
    cx: 551.327128,
    cy: 421.267845,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(584.404387, 443.195579) rotate(-89.566750) translate(-584.404387, -443.195579) ",
    cx: 584.404387,
    cy: 443.195579,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    transform: "translate(373.664674, 156.374791) rotate(-81.721740) translate(-373.664674, -156.374791) ",
    cx: 373.664674,
    cy: 156.374791,
    rx: 5.25681,
    ry: 7.55666
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(422.836199, 151.576737) rotate(-81.721740) translate(-422.836199, -151.576737) ",
    cx: 422.836199,
    cy: 151.576737,
    rx: 5.2568,
    ry: 7.55666
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF6584",
    transform: "translate(360.200061, 116.566638) rotate(-81.721740) translate(-360.200061, -116.566638) ",
    cx: 360.200061,
    cy: 116.566638,
    rx: 5.25681,
    ry: 7.55666
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(342.989496, 101.323538) rotate(-89.566750) translate(-342.989496, -101.323538) ",
    cx: 342.989496,
    cy: 101.323538,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(335.743765, 70.951924) rotate(-89.566750) translate(-335.743765, -70.951924) ",
    cx: 335.743765,
    cy: 70.9519243,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6E6E6",
    transform: "translate(392.088935, 124.403835) rotate(-89.566750) translate(-392.088935, -124.403835) ",
    cx: 392.088935,
    cy: 124.403835,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FF6584",
    transform: "translate(368.327119, 136.267836) rotate(-89.566750) translate(-368.327119, -136.267836) ",
    cx: 368.327119,
    cy: 136.267836,
    rx: 4.77581,
    ry: 3.3223
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#3F3D56",
    transform: "translate(401.404388, 158.195570) rotate(-89.566750) translate(-401.404388, -158.195570) ",
    cx: 401.404388,
    cy: 158.19557,
    rx: 4.77581,
    ry: 3.3223
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.8179d41283f01111422575cc24409c85.svg";
export { ForwardRef as ReactComponent };